import _extends from "@babel/runtime/helpers/esm/extends";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";

var _class, _class2, _temp;

import React from 'react';
import { globalObject } from '@skbkontur/global-object';
import { getRandomID } from "../../../lib/utils";
import { isKeyArrowVertical, isKeyEnter, isKeyEscape, isKeySpace, someKeys } from "../../../lib/events/keyboard/identifiers";
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { ThemeFactory } from "../../../lib/theming/ThemeFactory";
import { Popup, PopupIds } from "../../Popup";
import { RenderLayer } from "../../RenderLayer";
import { CommonWrapper } from "../../../internal/CommonWrapper";
import { responsiveLayout } from "../../../components/ResponsiveLayout/decorator";
import { rootNode } from "../../../lib/rootNode";
import { createPropsGetter } from "../../../lib/createPropsGetter";
import { Menu } from "../../Menu";
import { isValidPositions } from "../validatePositions";
import { styles } from "../PopupMenu.styles";
export var PopupMenuType = {
  Dropdown: 'dropdown',
  Tooltip: 'tooltip'
};
export var PopupMenuDataTids = {
  root: 'PopupMenu__root',
  caption: 'PopupMenu__caption'
};
var Positions = ['top left', 'top center', 'top right', 'right top', 'right middle', 'right bottom', 'bottom left', 'bottom center', 'bottom right', 'left top', 'left middle', 'left bottom'];
export var PopupMenu = rootNode(_class = responsiveLayout(_class = (_temp = _class2 = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(PopupMenu, _React$Component);

  function PopupMenu() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.rootId = PopupIds.root + getRandomID();
    _this.getProps = createPropsGetter(PopupMenu.defaultProps);
    _this.state = {
      menuVisible: false,
      firstItemShouldBeSelected: false
    };
    _this.captionWrapper = null;
    _this.savedFocusableElement = null;
    _this.menu = null;

    _this.open = function () {
      return _this.showMenu();
    };

    _this.close = function () {
      return _this.hideMenu();
    };

    _this.refInternalMenu = function (element) {
      return _this.menu = element;
    };

    _this.handleOpen = function () {
      if (_this.menu) {
        _this.menu.focus();
      }
    };

    _this.passPropsToCaption = function (caption) {
      var _this$props$popupMenu;

      if (typeof caption === 'string' || typeof caption === 'number') {
        return caption;
      }

      return /*#__PURE__*/React.cloneElement(caption, {
        'aria-controls': (_this$props$popupMenu = _this.props.popupMenuId) != null ? _this$props$popupMenu : _this.rootId,
        'aria-expanded': _this.state.menuVisible ? 'true' : 'false',
        'aria-label': _this.props['aria-label']
      });
    };

    _this.renderCaption = function () {
      if (typeof _this.props.caption === 'function') {
        var caption = _this.props.caption({
          opened: _this.state.menuVisible,
          openMenu: _this.showMenu,
          closeMenu: _this.hideMenu,
          toggleMenu: _this.toggleMenu
        });

        return /*#__PURE__*/React.createElement("span", {
          "data-tid": PopupMenuDataTids.caption,
          className: styles.caption(),
          ref: function ref(element) {
            return _this.captionWrapper = element;
          }
        }, _this.passPropsToCaption(caption));
      }

      return /*#__PURE__*/React.createElement("span", {
        "data-tid": PopupMenuDataTids.caption,
        onClick: _this.handleCaptionClick,
        onKeyDown: _this.handleCaptionKeyDown,
        ref: function ref(element) {
          return _this.captionWrapper = element;
        },
        className: styles.caption()
      }, _this.passPropsToCaption(_this.props.caption));
    };

    _this.hideMenuWithoutFocusing = function () {
      return _this.hideMenu();
    };

    _this.showMenu = function (firstItemShouldBeSelected) {
      _this.saveFocus();

      _this.setState({
        menuVisible: true,
        firstItemShouldBeSelected: firstItemShouldBeSelected
      }, function () {
        _this.handleChangeMenuVisible(false);
      });
    };

    _this.hideMenu = function (restoreFocus) {
      _this.setState({
        menuVisible: false,
        firstItemShouldBeSelected: false
      }, function () {
        _this.handleChangeMenuVisible(!!restoreFocus);
      });
    };

    _this.toggleMenu = function () {
      _this.state.menuVisible ? _this.hideMenu() : _this.showMenu();
    };

    _this.handleCaptionClick = function () {
      _this.toggleMenu();
    };

    _this.handleCaptionKeyDown = function (e) {
      if (someKeys(isKeyEnter, isKeySpace, isKeyArrowVertical)(e)) {
        e.preventDefault();

        _this.showMenu(true);
      }
    };

    _this.handleKeyDown = function (e) {
      if (isKeyEscape(e)) {
        var _restoreFocus = true;

        _this.hideMenu(_restoreFocus);
      }
    };

    _this.saveFocus = function () {
      if (globalObject.document) {
        _this.savedFocusableElement = globalObject.document.activeElement;
      }
    };

    _this.restoreFocus = function () {
      if (_this.savedFocusableElement) {
        _this.savedFocusableElement.focus();

        _this.savedFocusableElement = null;
      }
    };

    _this.handleChangeMenuVisible = function (focusShouldBeRestored) {
      if (focusShouldBeRestored) {
        _this.restoreFocus();
      }

      if (_this.state.menuVisible && _this.props.onOpen) {
        _this.props.onOpen();
      }

      if (!_this.state.menuVisible && _this.props.onClose) {
        _this.props.onClose();
      }

      if (typeof _this.props.onChangeMenuState === 'function') {
        _this.props.onChangeMenuState(_this.state.menuVisible, focusShouldBeRestored);
      }
    };

    _this.handleItemSelection = function (event) {
      if (event.isDefaultPrevented()) {
        return;
      }

      if (event.type === 'keydown') {
        event.preventDefault();
      }

      var restoreFocus = event.type === 'keydown';

      _this.hideMenu(restoreFocus);
    };

    return _this;
  }

  var _proto = PopupMenu.prototype;

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (theme) {
      return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
        value: ThemeFactory.create({
          menuOffsetY: theme.popupMenuMenuOffsetY
        }, theme)
      }, _this2.renderMain());
    });
  };

  _proto.renderMain = function renderMain() {
    var _this$props$popupMenu2;

    var _this$getProps = this.getProps(),
        popupHasPin = _this$getProps.popupHasPin,
        disableAnimations = _this$getProps.disableAnimations;

    return /*#__PURE__*/React.createElement(CommonWrapper, _extends({
      rootNodeRef: this.setRootNode
    }, this.props), /*#__PURE__*/React.createElement(RenderLayer, {
      onClickOutside: this.hideMenuWithoutFocusing,
      onFocusOutside: this.hideMenuWithoutFocusing,
      active: this.state.menuVisible
    }, /*#__PURE__*/React.createElement("div", {
      "data-tid": PopupMenuDataTids.root,
      className: styles.container(),
      style: {
        width: this.props.width
      }
    }, this.renderCaption(), this.captionWrapper && this.props.children && /*#__PURE__*/React.createElement(Popup, {
      id: (_this$props$popupMenu2 = this.props.popupMenuId) != null ? _this$props$popupMenu2 : this.rootId,
      anchorElement: this.captionWrapper,
      opened: this.state.menuVisible,
      hasShadow: true,
      margin: this.props.popupMargin,
      hasPin: popupHasPin,
      pinOffset: this.props.popupPinOffset,
      positions: this.getPositions(),
      disableAnimations: disableAnimations,
      onOpen: this.handleOpen,
      mobileOnCloseRequest: this.hideMenu,
      width: this.isMobileLayout ? 'auto' : this.props.menuWidth || 'auto'
    }, /*#__PURE__*/React.createElement(Menu, {
      hasShadow: false,
      maxHeight: this.isMobileLayout ? 'none' : this.props.menuMaxHeight || 'none',
      onKeyDown: this.handleKeyDown,
      onItemClick: this.handleItemSelection,
      preventIconsOffset: this.props.preventIconsOffset,
      cyclicSelection: false,
      ref: this.refInternalMenu,
      initialSelectedItemIndex: this.state.firstItemShouldBeSelected ? 0 : -1,
      header: this.props.header,
      footer: this.props.footer
    }, this.props.children)))));
  };

  _proto.getPositions = function getPositions() {
    var positions = this.getProps().positions;

    if (positions && isValidPositions(positions)) {
      return positions;
    }

    return Positions;
  };

  return PopupMenu;
}(React.Component), _class2.__KONTUR_REACT_UI__ = 'PopupMenu', _class2.displayName = 'PopupMenu', _class2.defaultProps = {
  positions: Positions,
  type: PopupMenuType.Tooltip,
  popupHasPin: true,
  disableAnimations: false
}, _class2.Type = PopupMenuType, _temp)) || _class) || _class;